import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import enTranslation from './locales/en.json';
import nbTranslation from './locales/nb.json';

const liveTranslations = new URLSearchParams(window.location.search).has('liveTranslations');

const instance = i18n.use(initReactI18next);

if (liveTranslations) {
  instance.use(HttpBackend);
}

void instance.init({
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'translation',
  supportedLngs: ['en', 'nb'],
  returnEmptyString: false,
  interpolation: { escapeValue: false },
  ...(liveTranslations
    ? {
        backend: {
          loadPath: '/api/translations/{{lng}}',
        },
      }
    : {
        resources: {
          en: { translation: enTranslation },
          nb: { translation: nbTranslation },
        },
      }),
});

export default i18n;
